export const FETCH_PRODUCTS = 'FETCH_PRODUCTS';
export const STORE_LIMIT = 'STORE_LIMIT';
export const SELECT_GRID = 'SELECT_GRID';
export const SELECT_LIMIT = 'SELECT_LIMIT';
export const UPDATE_PRODUCTS_COUNT = 'UPDATE_PRODUCTS_COUNT';
export const SET_PAGINATION = 'SET_PAGINATION';
export const SET_QUERY = 'SET_QUERY';
export const SET_PRODUCTS = 'SET_PRODUCTS';
export const SET_OVERLAY = 'SET_OVERLAY';
export const SET_SORT_ORDER = 'SET_SORT_ORDER';
export const SET_SORTING = 'SET_SORTING';
export const SET_SEO_DATA = 'SET_SEO_DATA';

export const ADD_FILTER = 'ADD_FILTER';
export const REMOVE_FILTER = 'REMOVE_FILTER';
export const CLEAR_FILTER = 'CLEAR_FILTER';
export const SET_CURRENT_PAGE = 'SET_CURRENT_PAGE';
export const SET_SELECTED_FILTERS = 'SET_SELECTED_FILTERS';
export const SET_PRICE_RANGE = 'SET_PRICE_RANGE';

export const SET_MODEL_IMAGE_MODE = 'SET_MODEL_IMAGE_MODE';
